module.exports = __webpack_public_path__ + "img/delete_video_af.80562f3d.svg";